export default "__VITE_ASSET__Cj2nM3v$__"